import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'

export function createOrganizationAccount(organizationId: string) {
  return httpClientBanking<{ singUpRequestId: string }>({
    url: `/organizations/${organizationId}/payment_account`,
    method: 'POST'
  })
}
